export default "__VITE_ASSET__27b309e2__"